import { ReactElement } from 'react';
import { LogicalSeatConfigAdmin } from '@mapado/seating';
import { Contract } from '@mapado/ticketing-js-sdk';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoLogicalSeatConfigAdmin(): ReactElement {
  const logicalSeatConfigId = useQueryNumberParam('logicalSeatConfigId', 244);

  return (
    <>
      <h3>Administration modèle de salle</h3>

      <LogicalSeatConfigAdmin
        contract={
          new Contract({
            '@id': '/v1/contracts/237 ',
            '@type': 'Contract',
          })
        }
        logicalSeatConfigId={logicalSeatConfigId}
      />
    </>
  );
}
